module.exports = __webpack_public_path__ + "static/media/sortering-innaktiv.b5a8e3ab.svg";